import { cn } from "@/lib/utils";

type DiscountGradientProps = {
  children: React.ReactNode;
  className?: string;
};

export const DiscountGradient = ({
  children,
  className,
}: DiscountGradientProps) => {
  return (
    <div
      className={cn(
        "bg-(image:--discount-gradient) px-4 py-2 font-bold text-sm text-white",
        className
      )}
    >
      {children}
    </div>
  );
};
